export default {
  placeholder: 'Please enter content',
  insertImage: 'Insert Image',
  insertVideo: 'Insert Video',
};
